"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WelcomeSkeleton = exports.WelcomePageLoader = exports.SearchResultsLoaderColumn = exports.ConversationalSearchResultsComponentLoader = exports.ConversationalSearchComponentLoader = exports.AiSearchBoxComponentLoader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _sharedComponents = require("@site/shared-components");
var _classnames = _interopRequireDefault(require("classnames"));
var _ConversationalSearch = require("../styles/ConversationalSearch");
const SearchResultsLoaderColumn = ({
  isModal
}) => {
  const mapper = new Array(4).fill(0);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "conversational-search-results-skeleton-loader",
    className: (0, _classnames.default)({
      'conversational-search-results-step-3': isModal
    })
  }, mapper.map((el, index) => /*#__PURE__*/_react.default.createElement("div", {
    key: index
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: index === 0 ? 'mt-5 mb-2' : 'my-2',
    height: "2.5rem",
    width: "20%"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex justify-content-between w-100 conv-search-results-skeleton-loader', {
      'mx-2': isModal
    })
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "mt-4 mx-2",
    height: "2.5rem",
    width: "45%"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    className: "my-2 mr-2",
    height: "4.5rem",
    width: "4.5rem"
  })))));
};
exports.SearchResultsLoaderColumn = SearchResultsLoaderColumn;
const WelcomeSkeleton = ({
  isModal
}) => {
  const shorterHeight = '1.5rem';
  const tallerHeight = '2.5rem';
  const skeletons = [{
    width: isModal ? '20%' : '12%',
    height: shorterHeight,
    class: 'mt-3 airo-logo-skeleton-loader'
  }, {
    width: isModal ? '55%' : '30%',
    height: tallerHeight,
    class: 'mt-2'
  }, {
    width: isModal ? '40%' : '17%',
    height: tallerHeight,
    class: 'mt-2'
  }, {
    width: isModal ? '50%' : '22%',
    height: shorterHeight,
    class: 'mt-2'
  }, {
    width: isModal ? '35%' : '13%',
    height: shorterHeight,
    class: 'mt-2'
  }];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "welcome-container",
    "data-testid": "welcome-skeleton-loader"
  }, skeletons.map((item, index) => /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    key: index,
    className: `${item.class}`,
    height: item.height,
    width: item.width
  })));
};
exports.WelcomeSkeleton = WelcomeSkeleton;
const WelcomePageLoader = ({
  isModal,
  isMobile,
  isDesktop,
  stickySearchBox
}) => {
  return isModal ? /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledModal, {
    "data-testid": "modal-styles"
  }, /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalSearchWrapper, {
    isMobile: isMobile,
    isDesktop: isDesktop
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "conversational-search-modal-container"
  }, /*#__PURE__*/_react.default.createElement(WelcomeSkeleton, {
    isModal: isModal
  }), /*#__PURE__*/_react.default.createElement(AiSearchBoxComponentLoader, {
    stickySearchBox: stickySearchBox
  })))) : /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalSearchWrapper, {
    isMobile: isMobile,
    isDesktop: isDesktop
  }, /*#__PURE__*/_react.default.createElement(WelcomeSkeleton, {
    isModal: isModal
  }), /*#__PURE__*/_react.default.createElement(AiSearchBoxComponentLoader, {
    stickySearchBox: stickySearchBox
  }));
};
exports.WelcomePageLoader = WelcomePageLoader;
const ConversationalSearchResultsComponentLoader = ({
  isModal = true
}) => {
  return /*#__PURE__*/_react.default.createElement(SearchResultsLoaderColumn, {
    isModal: isModal
  });
};
exports.ConversationalSearchResultsComponentLoader = ConversationalSearchResultsComponentLoader;
const AiSearchBoxComponentLoader = ({
  stickySearchBox = false
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "ai-search-box-skeleton-loader",
    className: (0, _classnames.default)('conversational-search-box-wrapper rounded-bottom-border', {
      fixed: stickySearchBox
    }, {
      absolute: !stickySearchBox
    })
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    height: "4.5rem",
    width: "100%"
  }));
};

// When forceEnableBFF is true, awaiting loading of ConversationalSearch component
exports.AiSearchBoxComponentLoader = AiSearchBoxComponentLoader;
const ConversationalSearchComponentLoader = ({
  searchQuery,
  stickySearchBox,
  isModal,
  isMobile,
  isDesktop
}) => {
  if (searchQuery && isModal) {
    return /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledModal, {
      "data-testid": "modal-styles"
    }, /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalSearchWrapper, {
      isMobile: isMobile,
      isDesktop: isDesktop,
      stickySearchBox: stickySearchBox
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "d-flex conv-search-results-skeleton-loader conversational-search-modal-container"
    }, /*#__PURE__*/_react.default.createElement(ConversationalSearchResultsComponentLoader, {
      isModal: isModal
    }), /*#__PURE__*/_react.default.createElement(AiSearchBoxComponentLoader, {
      stickySearchBox: stickySearchBox
    }))));
  } else if (searchQuery) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ConversationalSearchResultsComponentLoader, {
      isModal: isModal
    }), /*#__PURE__*/_react.default.createElement(AiSearchBoxComponentLoader, {
      stickySearchBox: stickySearchBox
    }));
  }
  return /*#__PURE__*/_react.default.createElement(WelcomePageLoader, {
    isModal: isModal,
    isMobile: isMobile,
    isDesktop: isDesktop
  });
};
exports.ConversationalSearchComponentLoader = ConversationalSearchComponentLoader;
ConversationalSearchResultsComponentLoader.propTypes = {
  isModal: _propTypes.default.bool
};
AiSearchBoxComponentLoader.propTypes = {
  stickySearchBox: _propTypes.default.bool
};
ConversationalSearchComponentLoader.propTypes = {
  searchQuery: _propTypes.default.string,
  stickySearchBox: _propTypes.default.bool,
  isModal: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  isDesktop: _propTypes.default.bool
};